const requestStatus = {
    BUSY: 'BUSY',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    ERROR: 'ERROR',
    COMPLETE: 'COMPLETE'
}

const standardHeaders = {
    CONTENT_TYPE: 'Content-type',
    AUTHORIZATION: 'Authorization'
}

const contentTypes = {
    APPLICATION_JSON: 'application/json; charset=utf-8',
    FORM_DATA: 'application/x-www-form-urlencoded',
    APPLICATION_PDF: 'application/pdf',
    VND_OPENXML: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

const fetchTypes = {
    APPROVAL_QUEUE: 'APPROVAL_QUEUE',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    COMPLETED_REPORT_SEARCH_EXPORT: 'COMPLETED_REPORT_SEARCH_EXPORT',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    GET_SECURITY: 'GET_SECURITY',
    PENDING_REPORT_SEARCH_EXPORT: 'PENDING_REPORT_SEARCH_EXPORT',
    PENDING_REPORT_SEARCH: 'PENDING_REPORT_SEARCH',
    REPORT_ACCESS: 'REPORT_ACCESS',
    REPORT_DATA: 'REPORT_DATA',
    REPORT_SEARCH: 'REPORT_SEARCH',
    RESET_PASSWORD: 'RESET_PASSWORD',
    SAMPLE_SEARCH: 'SAMPLE_SEARCH',
    SET_SECURITY: 'SET_SECURITY',
    TOKEN: 'TOKEN',
    USER_APPROVE: 'USER_APPROVE',
    USER_REJECT: 'USER_REJECT',
    USER_RESTORE_ACCESS: 'USER_RESTORE_ACCESS',
    USER_REVOKE_ACCESS: 'USER_REVOKE_ACCESS',
    USER_REVOKED_SEARCH: 'USER_REVOKED_SEARCH',
    USER_SEARCH: 'USER_SEARCH'
}

export {
    requestStatus,
    standardHeaders,
    contentTypes,
    fetchTypes
}



// WEBPACK FOOTER //
// ./web-app/constants/network-constants.js